import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Button, Flex, TextField } from "@hopper-ui/components";
import { useCallback, useState, type KeyboardEvent } from "react";

interface AddMemoryInputProps {
    onAdd: (value: string) => void;
}

export const AddMemoryInput = ({ onAdd }: AddMemoryInputProps) => {
    const { tShared } = useSharedTranslation();
    const [value, setValue] = useState("");

    const handleAdd = useCallback(() => {
        const trimmedValue = value.trim();

        if (trimmedValue) {
            onAdd(trimmedValue);
            setValue("");
        }
    }, [onAdd, value]);

    const handleKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleAdd();
        }
    }, [handleAdd]);

    return (
        <Flex gap="inline-sm">
            <TextField
                value={value}
                onChange={_value => setValue(_value)}
                onKeyDown={handleKeyDown}
                placeholder={tShared("personalization.addMemoryPlaceholder")}
                aria-label={tShared("personalization.addMemoryLabel")}
                isFluid
            />
            <Button
                variant="ghost-primary"
                onPress={handleAdd}
                flexShrink={0}
            >
                {tShared("personalization.addButton")}
            </Button>
        </Flex>
    );
};
